<template>
  <footer v-if="showFooter" class="app-footer">
    <span><a href="http://http://intellitrac.com.au/">Intellitrac</a> &copy; 2017 IntelliTrac Australia Pty. Ltd. All rights reserved.</span>
  </footer>
</template>
<script>
/* eslint-disable */
export default {
  name: 'footer_el',
  computed: {
    showFooter() {
      return this.$store.getters.useFooter;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue